import { ApiServiceBase } from '@@/api/services/ApiServiceBase'
import type { ApiPaginatedResponse } from '@@/api/types/Api'

export default class EarningsService extends ApiServiceBase {
  async get(query?: object | null): Promise<ApiPaginatedResponse<object>> {
    const params = query ?? {}
    return await this.call('/v1/earnings', params)
  }
}
